import { Table, Card, Grid, Checkbox  } from "antd";

const { useBreakpoint } = Grid;

function TablePCMoble({ ColumnsCase90, DataSourceTest, rowSelection, rowKey }) {
  const screens = useBreakpoint();

  return (
    <>
      {screens.md ? (
        // 👉 Desktop / Tablet
        <Table
          columns={ColumnsCase90}
          dataSource={DataSourceTest}
          rowSelection={rowSelection}
          rowKey={rowKey}
        />
      ) : (
        // 👉 Mobile (แนวตั้ง)
        <div>
          {DataSourceTest.map((item, rowIndex) => (
            <Card key={rowIndex} style={{ marginBottom: 12, width: "100%" }}>
              {ColumnsCase90.map((col, colIndex) => (
                <div
                  key={colIndex}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 8,
                    borderBottom: "1px solid #eee",
                    paddingBottom: 4,
                  }}
                >
                  <strong>{col.title}</strong>
                  <span>
                    {col.render
                      ? col.render(item[col.dataIndex], item, rowIndex)
                      : item[col.dataIndex]}
                  </span>
                </div>
              ))}
            </Card>
          ))}
        </div>
      )}
    </>
  );
}

export default TablePCMoble;
